import i18n from '@/locales/i18n'
import { CUSTOMERS_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const CUSTOMERS_LIST_ROUTE_NAME = 'customersList'
export const CUSTOMERS_DETAIL_ROUTE_NAME = 'customersDetail'

const routes: RouteType[] = [
    {
        path: CUSTOMERS_ROUTES.baseUrl,
        name: CUSTOMERS_LIST_ROUTE_NAME,
        component: () => import('@/views/CustomersView/CustomersListView.vue'),
        meta: {
            title: i18n.global.t('menu.customers'),
            authRequired: true
        }
    },
    {
        path: CUSTOMERS_ROUTES.detailUrl,
        name: CUSTOMERS_DETAIL_ROUTE_NAME,
        component: () => import('@/views/CustomersView/CustomerDetailView.vue'),
        meta: {
            title: i18n.global.t('menu.customers'),
            authRequired: true
        }
    }
]

export default routes
